import script from "./form-manufacturer-related.vue?vue&type=script&setup=true&lang=ts"
export * from "./form-manufacturer-related.vue?vue&type=script&setup=true&lang=ts"

import "./form-manufacturer-related.vue?vue&type=style&index=0&id=54794f4a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54794f4a"]])

export default __exports__